import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminAnalytics() {
  const [stats, setStats] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/admin/analytics`, { withCredentials: true });
        setStats(res.data);
      } catch (e) { setErr(e?.response?.data?.detail || "Failed to load"); }
    })();
  }, []);

  return (
    <section data-testid="admin-analytics">
      <h2 className="font-serif text-3xl md:text-4xl font-light mb-8 tracking-tight">
        Analytics
      </h2>
      {err && <p className="text-red-600 text-sm mb-4">{err}</p>}
      {!stats ? (
        <p className="text-[#0F1F4E]/70">Loading…</p>
      ) : (
        <>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-12">
            {[
              ["Page views", stats.page_views_total],
              ["Bookings", stats.bookings_total],
              ["Contacts", stats.contacts_total],
              ["Poll votes", stats.poll_votes_total],
              ["Posts", stats.blog_posts_total],
              ["Newsletter", stats.newsletter_subscribers_total],
            ].map(([label, val]) => (
              <div key={label} className="bg-white border border-[#D9CFA0] rounded-lg p-4">
                <div className="text-xs uppercase tracking-wider text-[#0F1F4E]/70 mb-1">{label}</div>
                <div className="font-serif text-3xl">{val ?? 0}</div>
              </div>
            ))}
          </div>

          <h3 className="font-serif text-2xl font-light mb-4">Top pages</h3>
          {stats.top_paths.length === 0 ? (
            <p className="text-sm text-[#0F1F4E]/70">No page views recorded yet.</p>
          ) : (
            <div className="overflow-x-auto bg-white border border-[#D9CFA0] rounded-lg">
              <table className="min-w-full text-sm">
                <thead className="bg-[#F2EBD3]">
                  <tr className="text-left text-xs uppercase tracking-wider text-[#0F1F4E]/70">
                    <th className="px-4 py-3">Path</th>
                    <th className="px-4 py-3">Views</th>
                  </tr>
                </thead>
                <tbody>
                  {stats.top_paths.map((row) => (
                    <tr key={row.path} className="border-t border-[#D9CFA0]/70">
                      <td className="px-4 py-3 font-mono">{row.path}</td>
                      <td className="px-4 py-3">{row.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </section>
  );
}
